import React, { useMemo } from 'react';
import { Menu } from '@ui/components/Menu/menu';
import { IMenuItem } from '@ui/components/Menu/IMenuItem';
import LangIcoComponent from './Lang-ico.component';
import getFlag from '@utils/getFlag';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    languages,
    langMap,
    onLangClick,
}: IProps) => {
    const langList: IMenuItem[] = useMemo(
        () =>
            languages.map((lang) => ({
                id: lang,
                text: langMap[lang],
                icon: <LangIcoComponent url={getFlag(lang)} />,
                onClick: onLangClick,
            })),
        [languages, lang, onLangClick],
    );

    return (
        <>
            <Menu
                label="language-selector"
                button={<LangIcoComponent url={getFlag(lang)} />}
                items={langList}
            />
        </>
    );
};

const LangSelectorComponent = React.memo(Component);

export default LangSelectorComponent;
